/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Utils
import { get, isString } from 'lodash';

// Components
import DropdownMenu from 'shared/ui/components/DropdownMenu.vue';
import BaseInput from 'shared/ui/components/form-components/BaseInput.vue';

const __vue_script__ = {
    name: 'ConditionPredicate',

    components: { DropdownMenu, BaseInput },

    props: {
        eventId: {
            type: String,
            default: null
        },

        field: {
            type: Object,
            required: true
        },

        predicate: {
            type: Object,
            default: () => ({ _init: true })
        },

        showSeparator: {
            type: Boolean,
            default: false
        },

        canAddPredicate: {
            type: Boolean,
            default: true
        },

        readOnly: {
            type: Boolean,
            default: false
        }
    },

    data() {
        return {
            editing: !this.predicate.hasOwnProperty('value'),
            externalFpExtIdsChoice: {
                '': this.$i18n.t('general.loading')
            },
            enableChoice: true
        };
    },

    computed: {
        builtInInput() {
            if (this.field.kind === 'display-only') {
                return Boolean(this.field.kind_options?.values);
            }
            return ['boolean', 'choice', 'choice-list', 'external', 'locale'].includes(this.field.kind);
        },

        hasTooltip() {
            return this.$te(`targeting.conditions_editor.fields_tooltips.${this.field.name}`);
        }
    },

    watch: {
        async field() {
            if (this.field.kind !== 'external' || !this.field.kind_options.single_doc) {
                return;
            }

            this.enableChoice = false;
            const type = this.field.kind_options.type;

            try {
                if (!this.eventId) {
                    throw {};
                }
                const backlinks = await this.$services.backlinks.getItemsByFpType(this.eventId, type);
                if (!backlinks.length) {
                    throw {};
                }

                this.externalFpExtIdsChoice = backlinks.reduce((acc, item) => {
                    acc[item.id] = item.text;
                    return acc;
                }, {});

                this.enableChoice = true;
            } catch (error) {
                console.error('[ConditionPredicate] Could not load backlinks', error.message);
                this.externalFpExtIdsChoice = {
                    '': this.$i18n.t('general.no_elements')
                };
            }
        },
    },

    methods: {
        /**
         * Gets the field name for the given predicate
         *
         * @returns {string} the proper label for the field
         */
        getFieldLabel() {
            const label = isString(this.field.label) ? this.field.label : this.field.name;
            return label || this.predicate.name;
        },

        /**
         * Gets the field value label for the given predicate
         *
         * @returns {string} the proper label for the field value
         */
        getFieldValueLabel() {
            const values = this.getValues();
            return get(values, this.predicate.value, this.predicate.value);
        },

        /**
         * Retrieves the tooltip text for the field.
         * This method is used to provide additional information or guidance
         * about the field to the user in the form of a tooltip.
         *
         * @returns {string} The tooltip text for the field.
         */
        getFieldTooltip() {
            return this.$t(`targeting.conditions_editor.fields_tooltips.${this.field.name}`);
        },

        /**
         * Gets all the value of the given predicate
         */
        getValues() {
            if (this.field.kind === 'boolean') {
                return {
                    true: this.$i18n.t('general.true'),
                    false: this.$i18n.t('general.false')
                };
            }

            if (this.field.kind === 'external') {
                return this.externalFpExtIdsChoice;
            }

            return get(this.field, 'kind_options.values', {});
        },

        /**
         * Emits an add event
         */
        add() {
            if (this.readOnly) {
                return;
            }

            this.$emit('add');
        },

        /**
         * Emits a remove event
         */
        remove() {
            if (this.readOnly) {
                return;
            }

            this.stopEditing();
            this.$emit('remove', this.predicate);
            this.onChange();
        },

        /**
         * Sets the predicate value on the currently editing predicate
         *
         * @param {string|boolean} value the value to set
         * @param {boolean} [continuous=false] whether the action is still going or not
         */
        setValue(value, continuous) {
            if (!this.enableChoice) {
                this.stopEditing();
                return;
            }
            if (this.field.kind === 'boolean') {
                value = value === 'true';
            }
            if (this.field.kind === 'number') {
                value = parseInt(value);
            }
            this.$emit('input', value);
            if (!continuous) {
                this.stopEditing();
            }
        },

        /**
         * Click on field name event handler
         * @param {MouseEvent} event
         */
        changeField(event) {
            if (this.readOnly) {
                return;
            }

            if (!this.predicate.value && this.predicate.value !== false) {
                event.stopImmediatePropagation();
                this.$emit('change-field');
            }
        },

        startEditing() {
            if (this.readOnly) {
                return;
            }

            this.editing = true;
        },

        /**
         * Stops the editing of the field value
         */
        stopEditing() {
            if (this.predicate.value || (this.field.kind === 'boolean' && this.predicate.value === false)) {
                this.editing = false;
            }
        },

        hideDropDown() {
            this.$refs.dropdown.hide(0, true);
        },

        onChange() {
            this.$emit('change', this.predicate);
        }
    }
};

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.predicate.name)?_c('div',{staticClass:"predicate",class:{ editing: _vm.editing, 'more-possible': _vm.canAddPredicate, 'no-more': !_vm.canAddPredicate, 'read-only': _vm.readOnly }},[_c('div',{staticClass:"outer-wrapper"},[_c('div',{staticClass:"field-value-wrapper",on:{"click":function($event){return _vm.startEditing()}}},[_c('span',{staticClass:"field",on:{"click":_vm.changeField}},[_vm._v(_vm._s(_vm.getFieldLabel())),(_vm.hasTooltip)?_c('i',{directives:[{name:"tooltip",rawName:"v-tooltip",value:(_vm.getFieldTooltip()),expression:"getFieldTooltip()"}],staticClass:"ic-info-fill"}):_vm._e()]),_c('span',{staticClass:"value"},[_vm._v(_vm._s(_vm.getFieldValueLabel()))]),(!_vm.readOnly)?_c('span',{staticClass:"remove",on:{"click":function($event){$event.stopPropagation();return _vm.remove()}}},[_c('i',{staticClass:"ic-x"})]):_vm._e()]),(_vm.canAddPredicate)?_c('span',{staticClass:"add",on:{"click":function($event){return _vm.add()}}},[_c('i',{staticClass:"ic-plus"})]):_vm._e()]),(_vm.editing)?_c('dropdown-menu',{ref:"dropdown",staticClass:"value-selector",attrs:{"start-open":true,"anchor-pos":"nw","hide-delay-after-click":_vm.builtInInput ? 500 : -1},on:{"away":_vm.stopEditing},scopedSlots:_vm._u([{key:"toggler",fn:function(ref){return [_c('span',[_vm._v(_vm._s(_vm.$t('targeting.conditions_editor.select_value')))])]}}],null,false,569572259)},[(_vm.builtInInput)?_c('ul',_vm._l((Object.keys(_vm.getValues())),function(value){return _c('li',{key:value},[_c('a',{staticClass:"has-action",on:{"click":function($event){return _vm.setValue(value)}}},[_vm._v(_vm._s(_vm.getValues()[value]))])])}),0):_c('div',{staticClass:"text-value"},[_c('base-input',{attrs:{"type":"text","name":"name","value":_vm.predicate.value,"placeholder":_vm.$t('targeting.conditions_editor.type_value'),"focused":true},on:{"change":_vm.onChange,"input":function (value) { return _vm.setValue(value, true); },"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }$event.stopPropagation();$event.preventDefault();return _vm.hideDropDown.apply(null, arguments)},"keydown":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }$event.stopPropagation();$event.preventDefault();},"click":function($event){$event.stopPropagation();}}})],1)]):_vm._e(),(_vm.showSeparator)?_c('span',{staticClass:"separator"},[_vm._v(_vm._s(_vm.$t('base.and')))]):_vm._e()],1):_vm._e()}
var __vue_staticRenderFns__ = []

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "ConditionPredicate.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__